<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('cdn.domain')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						<el-form-item label="上级推流" class="mb-0">
							<el-select v-model="from.tl" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" value="">
								</el-option>
								<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain + ' - 【' +item.name+ '】'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						
						<el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-select  v-model="from.username" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" value=""> 
								</el-option>
								<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item :label="$t('accountList.ac_id')" class="mb-0">
							<el-input size="small" v-model="from.ac_id"></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						
						
						<el-form-item :label="$t('live.type')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('live.type1')" :value="1"></el-option>
								<el-option :label="$t('live.type2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('live.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('live.status1')" :value="1"></el-option>
								<el-option :label="$t('live.status2')" :value="0"></el-option>
								
							</el-select>
						</el-form-item>
						
						<!-- <el-form-item :label="$t('accountList.account_status')" class="mb-0">
							<el-select v-model="from.account_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.zc')" :value="1"></el-option>
								<el-option :label="$t('accountList.yc')" :value="0"></el-option>
								<el-option :label="$t('accountList.dy')" :value="2"></el-option>
								<el-option :label="$t('accountList.zf')" :value="3"></el-option>
								
							</el-select>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('live.addDoamin')}}</el-button>
						
						
						
						<el-button class="tongzhidianbtn" size="small" v-if="layout.user.type==1" @click="openCertModel()" v-auth="'add'+auth_val" type="warning" >存储桶证书 <span v-if="tos_num>0" class="tongzhidian" ></span></el-button>
					</div>
			</template>
		</div>
		<img src="https://fflive1-69cb8ab1bf6b2.tos-ap-southeast-1.bytepluses.com/tl.bjingqk.com/live/test1/20260331134250134.jpeg" alt="">
		
		<!-- <img src="https://fflive1-68edc62fbd0fd.tos-ap-southeast-1.bytepluses.com/tstl.bjingqk.com-162/live/test1/20251016073003846.jpeg" alt=""> -->

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table
				:data="tableData"
				style="width: 100%"
				row-key="id"
				:tree-props="{ children: 'children' }"
				:row-class-name="getLiveDomainRowClass"
				@selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				<el-table-column fixed="left" align="center" label="播放" width="60">
				</el-table-column>
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column show-overflow-tooltip="" width="180" align="center" prop="domain" :label="$t('cdn.domain')">
				</el-table-column>
				
				
				<el-table-column width="220" align="center" prop="cname" label="CNAME">
					<template slot-scope="scope">
						
					<i class="el-icon-warning-outline mr-1" :class="scope.row.cname_status==1?'text-success':'text-danger'"  style="font-size: 18px;"></i>	
					<el-tooltip class="item" effect="light" :content="scope.row.cname" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.cname }}</span>
					 
					</el-tooltip>
					
					
					<span class="iconCopy" @click="copyText(scope.row.cname)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="200" prop="type" :label="$t('live.type')">
					<template slot-scope="scope">
						
						<el-tag  v-if="scope.row.type==1" type="success">{{$t('live.type1')}}</el-tag>
						<el-tag v-if="scope.row.type==2" type="info">{{$t('live.type2')}}</el-tag>
						
						
						
					</template>
				</el-table-column>
				
				
				
				
				
				<el-table-column width="120" align="center" prop="cloud_name" :label="$t('live.cloud')">
				</el-table-column>
				
				
				
				
				
				
				
				
					
						
				
				
							
				
				
			
				
				
				<el-table-column align="center" width="140" prop="user_name" :label="$t('accountList.getUser')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="100" prop="sort" :label="$t('live.statusMain')">
					<template slot-scope="scope">
						<el-button  v-auth="'edit'+auth_val"
							:type="scope.row.is_main ? 'success' : 'info'" 
							size="mini"
							@click="changeStatus(scope.row,'is_main')"
							plain>{{scope.row.is_main ? $t('live.status_main') : $t('live.status_pt')}}
						</el-button>
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center" width="200" prop="type" :label="$t('live.up_regoin')">
					<template slot-scope="scope">
						
						<span v-if="scope.row.up_regoin==1">{{$t('live.ChineseMainland')}}</span>
						<span v-if="scope.row.up_regoin==2">{{$t('live.Global')}}</span>
						<span v-if="scope.row.up_regoin==3">{{$t('live.gaAndAbroad')}}</span>
						
						
				
					</template>
				</el-table-column>
			
				
				<el-table-column align="center" show-overflow-tooltip="" width="140" prop="bind_domain" :label="$t('live.bindTl')">
					
				</el-table-column>
				
				
				
				
				
				
				
				
				
				<el-table-column align="center" width="200" prop="remark" :label="$t('accountList.remark')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.remark" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.remark }}</span>
					 
					</el-tooltip>
					
				
					</template>
				</el-table-column>			
				
				
				
				<el-table-column align="center" width="200" prop="remark" :label="$t('live.user_remark')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.user_remark" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.user_remark }}</span>
					 
					</el-tooltip>
					
				
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="sort" :label="$t('live.status')">
					<template slot-scope="scope">
						<el-button  v-auth="'edit'+auth_val"
							:type="scope.row.user_status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'user_status')"
							plain>{{scope.row.user_status ? $t('live.status1') : $t('live.status2')}}
						</el-button>
					</template>
				</el-table-column>
			
				<el-table-column align="center" width="100" prop="sort" :label="$t('live.sort')">
				</el-table-column>
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="get_time" :label="$t('accountList.getTime')">
				</el-table-column>
				
				
			
				
		
				<el-table-column :width="layout.user.type==1?250:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button  @click="toDetail(scope.row)" v-auth="'edit'+auth_val"  size="mini" plain type="success">{{$t('live.guan')}}</el-button>
							<el-button v-if="layout.user.type==1" size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">{{$t('adminList.operation')}}</el-button>
							
							
							<el-button v-if="layout.user.type==1" size="mini" plain type="info" v-auth="'del'+auth_val" @click="openTran(scope.row)">{{$t('tran.tran')}}</el-button>
							
							
							<el-button v-if="layout.user.type==1" size="mini" plain type="danger" v-auth="'del'+auth_val" @click="deleteItem(scope.row)">{{$t('adminList.delete')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('live.addDoamin') : $t('live.editDoamin')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				
				
				<div v-if="editIndex>0">
					<!-- 选择服务商 -->
					<el-form-item   :label="$t('live.cloud')" prop="cloud_id">
						<el-select   v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
					
					
					<!-- 选择分配用户 -->
					<el-form-item v-if="form.type==1"  :label="$t('accountList.getUser')" prop="cloud_id">
						<el-select   v-model="form.uid" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
					
					
					<!-- 关联推流域名 -->
					<el-form-item v-if="form.type==2"  :label="$t('live.bindTl')" prop="cloud_id">
						<el-select   v-model="form.bind_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
					
					
					
					
					
					<!-- 加速区域 -->
					<!-- <el-form-item v-if="form.type==2" :label="$t('live.up_regoin')" prop="up_regoin">
						<el-select   v-model="form.up_regoin" size="small" filterable :placeholder="$t('system.select')">
						
							<el-option v-for="item in agentData.up" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					
					
					
					<el-form-item :label="$t('live.sort2')" prop="sort">
						<el-input v-model="form.sort" :placeholder="$t('live.sort2')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item   :label="$t('live.status')">
						<el-radio-group   v-model="form.user_status" size="small">
							<el-radio :label="1" border>{{$t('live.status1')}}</el-radio>
							<el-radio :label="0" border>{{$t('live.status2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					
					
					<el-form-item :label="$t('cdn.remark')" prop="remark">
						<el-input v-model="form.remark" :placeholder="$t('cdn.remark')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
				</div>
				
				<div v-if="editIndex <=0">
					
					<el-steps class="mb-4" :align-center="true"  :active="form.now" >
					  <el-step :title="$t('live.set')"></el-step>
					  <el-step :title="$t('live.cnameset')"></el-step>
					</el-steps>
					
					<!-- CNAME添加 -->
					
					<div v-if="form.now==2">
						
						<el-form-item >
							<el-tag
								type="success"
								effect="plain">
								<i class="el-icon-circle-check mr-1" style="font-size: 14px;" ></i>{{$t('live.add_ok')}}
							</el-tag>
						</el-form-item>
						
						
						<el-form-item >
							<el-timeline>
							    <el-timeline-item color="#329dfb" :timestamp="$t('live.bz1')" placement="top">
							      
							    </el-timeline-item>
								
								<el-timeline-item color="#329dfb" :timestamp="$t('live.bz2')" placement="top">
								 
									<div class="nn_bor">
										 <div class="ml-3 d-flex">
											<div class="w-other">{{$t('cdn.domain')}}</div>
											<div>{{form.main_domain}}</div>
										 </div>
									 </div>
								  
								</el-timeline-item>
								
								<el-timeline-item color="#329dfb" :timestamp="$t('live.bz3')" placement="top">
									<div class="nn_bor">
										<div class="ml-3 d-flex">
											<div class="w-other">{{$t('live.hostType')}}</div>
											<div>CNAME</div>
										</div>
										
										<div class="ml-3 d-flex">
											<div class="w-other">{{$t('live.host')}}</div>
											<div>{{form.host}} <span class="iconCopy" @click="copyText(form.host)"><i class="iconfont icon-fuzhi"></i></span></div>
										</div>
										
										<div class="ml-3 d-flex">
											<div class="w-other">{{$t('live.hostValue')}}</div>
											<div>{{form.cname}} <span class="iconCopy" @click="copyText(form.cname)"><i class="iconfont icon-fuzhi"></i></span></div>
										</div>
									</div>
								  
								</el-timeline-item>
								
								
								<el-timeline-item color="#329dfb" :timestamp="$t('live.bz4')" placement="top">
									<div class="nn_bor p-2">
										
										<div  class="font-weight-bold"><span class="mr-2">{{form.type==1?$t('live.type1'):$t('live.type2')}}</span>{{form.domain}}</div>
										
										<el-tag  v-if="form.cname_status==1"
											type="success"
											effect="plain">
											<i class="el-icon-circle-check mr-1" style="font-size: 14px;" ></i>{{$t('live.pz_ok')}}
										</el-tag>
										
										<el-tag v-if="form.cname_status==0"
											type="danger"
											effect="plain">
											<i class="el-icon-error mr-1" style="font-size: 14px;" ></i>{{$t('live.pz_no')}} <el-button @click="checkLiveCnameStatus" :loading="form.load" :disabled="form.load" class="ml-2 mr-3" size="mini" type="primary">{{$t('live.cnameCheck')}}</el-button>
										</el-tag>
									</div>
								 
								</el-timeline-item>
								
								
							   
							    
							  </el-timeline>
						</el-form-item>
						
						
					</div>
					
					
					<div v-if="form.now==1">
						<!-- 域名类型 -->
						<el-form-item :label="$t('live.type')" prop="type">
							<el-select   v-model="form.type" size="small" filterable :placeholder="$t('system.select')">
							
								<el-option v-for="item in agentData.type" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<!-- 加速区域 -->
						<el-form-item v-if="form.type==2" :label="$t('live.up_regoin')" prop="up_regoin">
							<el-select   v-model="form.up_regoin" size="small" filterable :placeholder="$t('system.select')">
							
								<el-option v-for="item in agentData.up" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<!-- 域名 -->
						<el-form-item :label="$t('cdn.domain')" prop="domain">
							<el-input @input="changeDomain" v-model="form.domain" :placeholder="$t('cdn.domain')" clearable size="small" style="width: 85%;"></el-input>
						</el-form-item>
						
						
						<!-- 腾讯云 -->
						<el-form-item  :label="$t('tran.tx')" prop="tx">
							<el-select   v-model="form.tx" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
							<!-- <el-option  :label="$t('live.nosel')" :value="0"> -->
							</el-option>
								<el-option v-for="item in agentData.account.c4" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'+item.cname" :value="item.id">
								</el-option>
							</el-select>
							
						</el-form-item>
						
						<!-- 火山云 -->
						<el-form-item  :label="$t('tran.byte')" prop="byte">
							<el-select  v-model="form.byte" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
							<!-- <el-option  :label="$t('live.nosel')" :value="0"> -->
							</el-option>
								<el-option v-for="item in agentData.account.c21" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'" :value="item.id">
								</el-option>
							</el-select>
							
						</el-form-item>
						
						<!-- 网宿 -->
						<!-- <el-form-item  :label="$t('tran.ws')" prop="ws">
							<el-select   v-model="form.ws" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
							</el-option>
								<el-option  :label="$t('live.neSel')" value="">
								</el-option>
								<el-option v-for="item in agentData.account.c31" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'" :value="item.id">
								</el-option>
							</el-select>
							
						</el-form-item> -->
						
						<!-- 华为云 -->
						<el-form-item  :label="$t('tran.hw')" prop="hw">
							<el-select   v-model="form.hw" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
							
							</el-option>
								<el-option  :label="$t('live.neSel')" value="">
								</el-option>
								<el-option v-for="item in agentData.account.c5" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'" :value="item.id">
								</el-option>
							</el-select>
							
						</el-form-item>
						
						<!-- 备注 -->
						<el-form-item :label="$t('cdn.remark')" prop="remark">
							<el-input v-model="form.remark" :placeholder="$t('cdn.remark')" clearable size="small" style="width: 85%;"></el-input>
						</el-form-item>
						
						
									
						
						
						<!-- 归属验证 -->
						<el-form-item v-if="checkTXT">
							<span v-if="agentData.cloud[0].data[0].status==0" class="text-danger">{{$t('live.pleaseYz')}}</span>
							<el-tabs v-model="form.cloud_id" >
							   <el-tab-pane v-if="item.id==4 || item.id==1 " v-for="item in agentData.cloud" :key="item.id" :label="item.name" :name="String(item.id)">
														
								<div class="model_table">
									<el-table
									  :data="item.data"
									  style="width: 90%">
									  <el-table-column
									  align="center"
										prop="host"
										:label="$t('live.host')"
										>
										
										<template slot-scope="scope">
										<span>
											{{scope.row.host}}
										</span>
										
										<span class="iconCopy" @click="copyText(scope.row.host)"><i class="iconfont icon-fuzhi"></i></span>
										</template>
									  </el-table-column>
									  <el-table-column
									  align="center"
										prop="type"
										:label="$t('live.hostType')"
										>
									  </el-table-column>
									 
									  
									  <el-table-column
									  align="center"
										prop="value"
										:label="$t('live.hostValue')">
										
										<template slot-scope="scope">
										<span>
											{{scope.row.value}}
										</span>
										
										<span class="iconCopy" @click="copyText(scope.row.value)"><i class="iconfont icon-fuzhi"></i></span>
										</template>
									  </el-table-column>
									  
									  <el-table-column
									  align="center"
										prop="value"
										:label="$t('live.yz_status')">
										
										<template slot-scope="scope">
										<span class="text-success" v-if="scope.row.status==1">{{$t('live.yz_ok')}}
										
										</span>
										<span class="text-danger" v-if="scope.row.status==0">{{$t('live.yz_no')}}
										<span @click="checkTxtStatus(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
										</span>
										
										
										</template>
									  </el-table-column>
									  
									  
									</el-table>
								</div>					
								
								
							</el-tab-pane>
							   
							 </el-tabs>
						</el-form-item>
					</div>
					
				</div>
				
				
				
				
				
				
				
				
				
				
			
				
			</el-form>

			<div slot="footer"  class="dialog-footer text-center">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{form.now==0?$t('live.next'):$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('tran.tran')"
			:visible.sync="tranModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_tran" ref="form_tran" :model="form_tran" :label-width="layout.is_phone?'80px':'100px'">
		
		
				
				
				<!-- 腾讯云 -->
				<el-form-item  :label="$t('tran.tx')" prop="tx">
					<el-select :disabled="form_tran.type==2"  v-model="form_tran.tx" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
					<el-option  :label="$t('live.nosel')" :value="0">
					</el-option>
						<el-option v-for="item in agentData.account.c4" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'+item.cname" :value="item.id">
						</el-option>
					</el-select>
					
				</el-form-item>
				
				<!-- 火山云 -->
				<el-form-item  :label="$t('tran.byte')" prop="byte">
					<el-select   :disabled="form_tran.type==2"   v-model="form_tran.byte" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
					<el-option  :label="$t('live.nosel')" :value="0">
					</el-option>
						<el-option v-for="item in agentData.account.c21" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'" :value="item.id">
						</el-option>
					</el-select>
					
				</el-form-item>
				
				
				<!-- 华为云 -->
				<el-form-item  :label="$t('tran.hw')" prop="hw">
					<el-select   :disabled="form_tran.type==2"  v-model="form_tran.hw" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
					<el-option  :label="$t('live.nosel')" :value="0">
					</el-option>
						<el-option v-for="item in agentData.account.c5" :key="item.id" :label="'['+item.id + '] ' +item.username+' ('+item.ac_id+')'" :value="item.id">
						</el-option>
					</el-select>
					
				</el-form-item>
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="tranModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitTran">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		<!-- 存储桶证书 -->
		<el-dialog :close-on-click-modal="false"
			title="存储桶证书"
			:visible.sync="tosCertModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="certSubRules" ref="cert_Sub" :model="certSub" :label-width="layout.is_phone?'80px':'100px'">
		
		
				
				
			 <el-tabs v-model="certactiveName" >
				<el-tab-pane label="存储桶证书" name="list"></el-tab-pane>
				<el-tab-pane label="播放证书" name="play"></el-tab-pane>
				<el-tab-pane label="添加" name="add"></el-tab-pane>
				
			  </el-tabs>
			  
			    <el-table v-show="certactiveName=='list'"
			      :data="certData.tos"
			      border
			      style="width: 100%">
			      <el-table-column prop="name" label="用户" align="center">
					  <template slot-scope="scope">
					  	<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
					  	
					  </template>
				  </el-table-column>
				  
				  <el-table-column prop="domain" label="域名" align="center"></el-table-column>
				  <el-table-column label="当前状态"  align="center">
					   <template slot-scope="scope" >
							<span v-if="scope.row.status==0">待申请证书</span>
							<span v-if="scope.row.status==1">正常</span>
					   </template>
				  </el-table-column>
				  <el-table-column prop="cert_end" width="180" label="证书到期时间"  align="center">
					  <template slot-scope="scope" >
						  <span :style="{ color: getColor(scope.row.cert_end) }">
							  {{scope.row.cert_end}}
						  </span>
					   </template>
				  </el-table-column>
				  
				  <el-table-column  label="新申请状态"  align="center">
						   <template slot-scope="scope" >
								<span v-if="scope.row.new_status==0">待申请证书</span>
								<span v-if="scope.row.new_status==1">已完成</span>
								<span v-if="scope.row.new_status==2">配置中</span>
						   </template>
				  </el-table-column>
				  
				  <el-table-column width="100" label="证书内容"  align="center">
						   <template slot-scope="scope" >
								<span class="iconCopy" @click="copyText(scope.row.cert_crt)"><i class="iconfont icon-fuzhi"></i></span>
						   </template>
				  </el-table-column>
				  
				  <el-table-column  width="100" label="证书私钥"  align="center">
						   <template slot-scope="scope" >
								<span class="iconCopy" @click="copyText(scope.row.cert_key)"><i class="iconfont icon-fuzhi"></i></span>
						   </template>
				  </el-table-column>
				  <el-table-column width="180" label="操作"  align="center">
					  <el-button size="small" :loading="layout.loading" :disabled="layout.loading" @click="applyTosCert(scope.row.id)" type="warning"> 申请证书</el-button>
					  <el-button size="small" :loading="layout.loading" :disabled="layout.loading"  @click="updateTosCert(scope.row.id)" type="success"> 已处理</el-button>
				  </el-table-column>

			    </el-table>
				
				<el-table v-show="certactiveName=='play'"
				  :data="certData.play"
				  border
				  style="width: 100%">
				  
				
	
				  <el-table-column prop="domain" label="域名" align="center">
					
				  </el-table-column>
				  <el-table-column prop="cert_end" label="证书到期时间"  align="center">
					  <template slot-scope="scope" >
						  <span :style="{ color: getColor(scope.row.cert_end) }">
							  {{scope.row.cert_end}}
						  </span>
					   </template>
				  </el-table-column>
				  <el-table-column  label="操作"  align="center">
					  <template slot-scope="scope" >
						<el-button  @click="toDetail(scope.row)" v-auth="'edit'+auth_val"  size="mini" plain type="success">{{$t('live.guan')}}</el-button>
					  </template>
				  </el-table-column>
				
				</el-table>
				
				
			  
			  <el-form-item v-if="certactiveName=='add'" :label="$t('payList.uid')" prop="uid" >
			  	<el-select  v-model="certSub.uid" size="small" filterable :placeholder="$t('system.select')">
			  		<!-- <el-option  :label="$t('status.all')" value=""> 
			  		</el-option> -->
			  		<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
			  		</el-option>
			  	</el-select>
			  </el-form-item>
			  
			  
			  <el-form-item v-if="certactiveName=='add'" label="域名" prop="domain">
			  	<el-input v-model="certSub.domain" placeholder="域名" clearable size="small" style="width: 85%;"></el-input>
			  </el-form-item>
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="tosCertModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button v-if="certactiveName=='add'" :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitCert">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				tos_num:0,
				certData:{
					tos:[],
					play:[]
				},
				certSub:{
					uid:'',
					domain:''
				},
				certactiveName:"list",
				tosCertModel:false,
				tranModel:false,
				createModel: false,
				editIndex: -1,
				
				checkTXT:false,
				//搜索數据
				from: {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					tl:'',
					cloud_id:-1,
					ac_id:'',
					time:[],
				},
				auth_val: 'LiveDomain',
				odds:0,
				preUrl: "data/livedomainList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delLivedomain", //删除單条地址
				addUrl: "data/addLivedomain", //添加/修改地址
				editStatusUrl:"data/editStatusLivedomain",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				form_tran:{
				},
				certSubRules:{
					uid:[{
						required: true,
						message: '请选择会员',
						trigger: 'blur',
					}],
					domain:[{
						required: true,
						message: '请输入域名',
						trigger: 'blur',
					}],
				},
				rules_tran:{
					tx:[{
						required: true,
						message: this.$t('tran.seltx'),
						trigger: 'blur',
					}],
					hw:[{
						required: true,
						message: this.$t('tran.selhw'),
						trigger: 'blur',
					}],
					byte:[{
						required: true,
						message: this.$t('tran.selbyte'),
						trigger: 'blur',
					}],
				},
				rules: {
					type: [{
						required: true,
						message: this.$t('live.seltype'),
						trigger: 'blur',
					}],
					up_regoin: [{
						required: true,
						message: this.$t('live.selUp_regoin'),
						trigger: 'blur',
					}],
					domain: [{
						required: true,
						message: this.$t('live.inpDomain'),
						trigger: 'blur'
					},
					{
					    validator: (rule, value, callback) => {
					      if (!value) return callback();
					
					      if (value.startsWith('*.')) {
					        return callback(new Error(this.$t('live.noFan')));
					      }
					
					      const domainRegex = /^(?!\-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;
					      if (!domainRegex.test(value)) {
					        return callback(new Error(this.$t('live.noDomain')));
					      }
					
					      // 模拟公共后缀列表
					      const publicSuffixes = [
					        'com', 'net', 'org', 'cn',
					        'com.cn', 'net.cn', 'org.cn',
					        'gov.cn', 'edu.cn', 'top', 'xyz', 'tv', 'ai', 'vip'
					      ];
					
					      const parts = value.split('.');
					      let suffix = '';
					      for (let i = parts.length - 1; i >= 0; i--) {
					        suffix = parts.slice(i).join('.');
					        if (publicSuffixes.includes(suffix)) {
					          const hostParts = parts.slice(0, i);
					          // 要求至少两个主机 label（如：play.test.com 或 abc.def.com.cn）
					          if (hostParts.length >= 2) {
					            return callback(); // 合法二级域名
					          } else {
					            return callback(new Error(this.$t('live.inpTwoDomain')));
					          }
					        }
					      }
					
					      return callback(new Error(this.$t('live.noDomainEnd')));
					    },
					    trigger: 'blur'
					  }
					],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					parent: [{
						required: true,
						message: this.$t('accountList.selMainAc'),
						trigger: 'blur',
					}],
					ac_id: [{
						required: true,
						message: this.$t('accountList.inp_ac_id'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
					sup_id:[{
						required: true,
						message: this.$t('new1.selSup'),
						trigger: 'blur',
					}],
					
					tx:[{
						required: true,
						message: this.$t('tran.seltx'),
						trigger: 'blur',
					}],
					// hw:[{
					// 	required: true,
					// 	message: this.$t('tran.selhw'),
					// 	trigger: 'blur',
					// }],
					byte:[{
						required: true,
						message: this.$t('tran.selbyte'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[],
				
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('liveDomain');
		},
		methods: {
			getLiveDomainRowClass({ row }) {
				if (row.type == 2 && row.bind_id > 0) {
					return 'live-domain-child-row';
				}
				if (row.type == 1 && row.children && row.children.length) {
					return 'live-domain-parent-row';
				}
				return '';
			},
			
			getColor(endTime) {
			    const now = new Date();
			    const end = new Date(endTime);
			    const diff = end - now;
			
			    if (diff < 0) return 'red';               // 已過期
			    if (diff < 20 * 24 * 60 * 60 * 1000) return 'orange'; // 7天內過期
			    return 'black';                           // 正常
			  },
			
			toDetail(item){
				let commonDetailPage = {}
				commonDetailPage.id = item.id
				commonDetailPage.name = item.domain
				commonDetailPage.type = item.type
				commonDetailPage.page = 'live_domain'
				commonDetailPage.url = 'live_detaildo'
				
				localStorage.setItem('commonDetailPage',JSON.stringify(commonDetailPage));
				this.$router.push({
					name: commonDetailPage.url
				})
			},
			changeDomain(){
				this.checkTXT = false
			},
			getBtnType(status){
				if(status==1){
					return 'success';
				}else if(status==0){
					return 'danger';
				}else if(status==3){
					return 'warning';
				}else{
					return 'info';
				}
			},
			openTran(e){
				this.form_tran = {
					id:e.id,
					type:e.type,
					tx:e.aids.tx,
					hw:e.aids.hw,
					byte:e.aids.byte,
				}
				this.tranModel = true
			},
			submitTran(){
				this.$refs.form_tran.validate(res => {
					
					if (res) {
						this.submitTranApi()
					}
				})
			},
			submitCert(){
				this.$refs.cert_Sub.validate(res => {
					
					if (res) {
						this.submitCertApi()
					}
				})
			},
			submitCertApi(){
				
				this.layout.loading = true;
				this.axios.post('/admin/data/subSetUserTosCert', this.certSub, {
					token: true,
				}).then(res => {
					let all = res.data;
					//console.log(all)
					if (all.code == 1) {
						this.$message.success(this.$t('system.openSucc'));
						this.tranModel = false
					}
					
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			applyTosCert(id){
				
				this.layout.loading = true;
				this.axios.post('/admin/data/applyTosCert', {id:id}, {
					token: true,
				}).then(res => {
					let all = res.data;
					
					if (all.code == 1) {
						this.getTosCertList()
						this.$message.success(this.$t('system.openSucc'));
						
					}
					
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			updateTosCert(id){
				
				this.layout.loading = true;
				this.axios.post('/admin/data/updateTosCert', {id:id}, {
					token: true,
				}).then(res => {
					let all = res.data;
					if (all.code == 1) {
						this.getTosCertList()
						this.$message.success(this.$t('system.openSucc'));
						
					}
					
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			checkTxtStatus(data){
				data.load = 1
				this.axios.post('/admin/data/checkLiveDomainCheck', {
					type:this.form.type,
					domain:this.form.domain,
					cloud_id:this.form.cloud_id,
					account_id:this.form.account_id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(list)
					data.status = list
					data.load = 0
				}).catch(err => {
					// 失敗
					data.load = 0
				})
			},
			submitTranApi(data){
				
				this.layout.loading = true;
				this.axios.post('/admin/data/tranLiveDomainAccount', this.form_tran, {
					token: true,
				}).then(res => {
					let all = res.data;
					//console.log(all)
					if (all.code == 1) {
						this.getTosCertList()
						this.$message.success(this.$t('system.openSucc'));
						this.certactiveName = 'list'
						this.certSub = {
							uid:'',
							domain:''
						}
					}
					
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changePassShowEmail(item){
				item.showPassEmail = item.showPassEmail==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			
			//提交
			submit() {

				this.$refs.form.validate(res => {
					console.log(this.checkTXT)
					console.log(this.form.now)
					if (res) {
						
						if(this.editIndex>0){
							this.form.id = this.editIndex
							this.addOrEdit(this.form)
						}else{
							if(this.form.now==1){
								
								if(this.checkTXT){
									if(this.agentData.cloud[0].data[0].status == 1 ){
										this.checkLiveDomainInfo()
									}else{
										this.$message.error(this.$t('live.pleaseYz'));
										
										return false
									}
								}else{
									this.checkLiveDomainInfo()
								}
							}else{
								this.createModel = false
								this.getList()
							}
						}
						
						
					}
				})
			},
			
			checkLiveDomainInfo() {
				this.layout.loading = true;
				this.axios.post('/admin/data/checkLiveDomainInfo', this.form, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.form.main_domain = list.main_domain
					this.form.host = list.host
					this.form.cname = list.cname
					this.form.account_id = list.account_id
					
					this.agentData.cloud[0].data = list.tx
					//this.agentData.cloud[2].data = list.gy
					
					if(list.is_txt==1){
						this.form.now = 2
						
					}

					this.checkTXT = true
					//console.log(this.agentData.cloud)
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			checkLiveCnameStatus() {
				this.form.load = true;
				this.axios.post('/admin/data/checkLiveCnameStatus', this.form, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(list==1){
						this.form.cname_status = 1
					}
					
					this.form.load = false;
				}).catch(err => {
					// 失敗
					this.form.load = false
				})
			},
			openCertModel(){
				this.tosCertModel = true
				this.getTosCertList()
			},
			getTosCertList() {
				this.layout.loading = true;
				this.axios.post('/admin/data/getTosCertList', {
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.certData = list

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				this.checkTXT = false
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						now:1,
						cloud_id: String(this.agentData.cloud[0].id),
						type:1,
						up_regoin:1,
						domain:'',
						host:'',
						main_domain:'',
						remark:'',
						cname:'',
						account_id:0,
						cname_status:0,
						load:false,
						tx:'',
						hw:'',
						ws:'',
						byte:'',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						user_name:e.user_name,
						uid:e.uid,
						cloud_id:e.cloud_id,
						cloud_name:e.cloud_name,
						uid:e.uid,
						user_name:e.user_name,
						remark:e.remark,
						type:e.type,
						bind_id:e.bind_id,
						up_regoin:e.up_regoin,
						user_status:e.user_status,
						sort:e.sort,
	
					}
					this.editIndex = e.id
					
					if(e.type==2){
						this.commonList('tlDomain',e.id);
					}
					
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					if(type=='liveDomain'){
						this.agentData = list
					}else{
						this.agentData.tl = list.tl
					}
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
					const isJPG = file.type === 'image/jpeg';
					const isLt2M = file.size / 1024 / 1024 < 2;
			
					// if (!isJPG) {
					//   this.$message.error('上傳头像图片只能是 JPG 格式!');
					// }
					// if (!isLt2M) {
					//   this.$message.error('上傳头像图片大小不能超過 2MB!');
					// }
					return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.tos_num = e.tos_num
				// this.check_img_list = e.list.map(item=>{
				// 	return item.head
				// })
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}


.model_table .el-table .el-table__cell{
	padding: 0px 0;
}

.live-domain-parent-row > td {
	background-color: #f1fbf3 !important;
}

.live-domain-child-row > td {
	background-color: #f2f7ff !important;
}

.live-domain-parent-row:hover > td {
	background-color: #e6f7ea !important;
}

.live-domain-child-row:hover > td {
	background-color: #e8f2ff !important;
}

.w-other{
	width: 100px;
}
.nn_bor{ 
	border: 1px solid #ccc;
	width: 90%;
	border-radius: 5px;
}
.tongzhidianbtn {
	position: relative;
}
.tongzhidianbtn .tongzhidian{
	position: absolute;
	top: -5px;
	right: -5px;
	width: 10px;
	height: 10px;
	background: red;
	border-radius: 50%;
}
</style>
